import React from 'react';
import { Menu, X } from 'lucide-react';
import { BsTwitterX } from "react-icons/bs";

const MobileNav = ({ isOpen, toggleMenu, children }) => {
  // Navigation links section at the top
  const navSection = (
    <div className="flex flex-col items-center space-y-8 mb-12">
      {children}
    </div>
  );

  // Footer navigation section
  const footerNav = (
    <div className="w-full px-6 border-t border-fuchsia-600/30 pt-8">
      <div className="grid grid-cols-2 gap-x-8 gap-y-6">
        <div>
          <h3 className="text-lg font-bold text-fuchsia-400 mb-3">About NFN</h3>
          <ul className="space-y-2">
            <li><a href='#top' className="text-gray-300">About Us</a></li>
            <li><a href='#top' className="text-gray-300">Contact</a></li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-bold text-fuchsia-400 mb-3">Resources</h3>
          <ul className="space-y-2">
            <li><a href='#top' className="text-gray-300">Newsletter</a></li>
          </ul>
        </div>

        <div className="col-span-2 flex justify-center pt-4">
          <a 
            href="https://twitter.com/nonfungiblenews" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-300 hover:text-white transition-colors"
          >
            <BsTwitterX className="w-5 h-5" />
          </a>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* Hamburger Button */}
      <button
        onClick={toggleMenu}
        className="lg:hidden fixed top-8 right-4 z-50 p-2 text-white"
      >
        {isOpen ? (
          <X className="w-8 h-8" />
        ) : (
          <Menu className="w-8 h-8" />
        )}
      </button>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 transform ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        } transition-transform duration-300 ease-in-out lg:hidden`}
      >
        <div className="absolute inset-0 bg-black/95 backdrop-blur-lg">
          <div className="flex flex-col h-full pt-24 pb-8">
            {navSection}
            {footerNav}
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNav;